import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import RequestOriginalButton from '../../../originals/RequestOriginalButton';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
}

export const RequestOriginalActionBarButton: React.FC<
  React.PropsWithChildren<Props>
> = ({ deviation, className }) => {
  return (
    <ActionBarItemWrapper className={className}>
      <RequestOriginalButton deviation={deviation} size="medium" sectionname="action_bar" />
    </ActionBarItemWrapper>
  );
};
RequestOriginalActionBarButton.displayName = 'RequestOriginalActionBarButton';

export default RequestOriginalActionBarButton;
